import { useEffect, useRef, useState } from 'react';

export function useCollapse(
    isActive: boolean, // ВАЖНО: именно isActive из useAnimatedMount
    duration = 300,
    collapsedHeight = 0,
) {
    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number | 'auto'>(0);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        if (isActive) {
            // ОТКРЫТИЕ

            // стартуем с collapsedHeight
            setHeight(collapsedHeight);

            requestAnimationFrame(() => {
                if (!ref.current) return;

                const fullHeight = ref.current.scrollHeight;
                setHeight(fullHeight);

                // после анимации → auto
                setTimeout(() => {
                    setHeight('auto');
                }, duration);
            });
        } else {
            // ЗАКРЫТИЕ

            const currentHeight =
                height === 'auto' ? el.scrollHeight : Number(height);

            setHeight(currentHeight);

            requestAnimationFrame(() => {
                setHeight(collapsedHeight);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, collapsedHeight]);

    return {
        ref,
        style: {
            height,
            overflow: 'hidden',
            transition: `height ${duration}ms ease`,
        },
    };
}
